import { api } from "./config/axios";

const API_URL = `${process.env.GATSBY_BACKEND_URL}/subscriptions`;

class SubscriptionService {
  checkout = async () => {
    const response = await api.post(API_URL + "/create-checkout-session/", {
      headers: {
        "Content-Type": "application/json",
      },
    });

    return response.data;
  };

  customerPortal = async () => {
    const response = await api.post(`${API_URL}/manage-portal-session/`, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    return response.data;
  };

  status = async () => {
    const response = await api.get(`${API_URL}/subscription-status/`, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    return response.data;
  };
}

export const SubscriptionsAPI = new SubscriptionService();
